import ApplicationSerializer from 'admin-panel/serializers/application';

export default class IntegrationsConfigurationRevisionSerializer extends ApplicationSerializer {
  serialize(...args: Parameters<ApplicationSerializer['serialize']>) {
    const json = super.serialize(...args) as Record<string, unknown>;

    json['integrations_configuration_id'] = json['configuration_id'];
    delete json['configuration_id'];

    return json;
  }
}

declare module 'ember-data/types/registries/serializer' {
  export default interface SerializerRegistry {
    'integrations/configuration-revision': IntegrationsConfigurationRevisionSerializer;
  }
}
